import { createBrowserRouter, Navigate } from 'react-router-dom';
import RequireAuth from '@/components/layout/RequireAuth';
import { RequireAdmin, RequireAdminOrFinance } from '@/components/layout/RequireRole';
import AppLayout from '@/components/layout/AppLayout';
import Login from '@/pages/Login';
import Home from '@/pages/Home';
import Members from '@/pages/Members';
import Payees from '@/pages/Payees';
import PayoutApplications from '@/pages/PayoutApplications';
import PayoutBatchImport from '@/pages/PayoutBatchImport';
import AiBatchApplications from '@/pages/AiBatchApplications';
import Payouts from '@/pages/Payouts';
import CollectionLinks from '@/pages/CollectionLinks';
import Settings from '@/pages/Settings';
import NotFound from '@/pages/NotFound';

/**
 * 路由表。用 data router（createBrowserRouter）而不是 <Routes>：loader / action /
 * errorElement 这些能力只在 data router 下可用，一开始就走这条路，免得后面整体搬。
 *
 * /login 是**唯一**在登录墙之外的页面。新增页面默认放进 RequireAuth 的 children 里。
 */
export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/',
        element: <AppLayout />,
        children: [
          { index: true, element: <Home /> },
          { path: 'collection-links', element: <CollectionLinks /> },
          { path: 'payees', element: <Payees /> },
          // 「我的资料」已并入概览页。老链接（收藏夹、邮件里）直接送回首页，
          // 而不是落到 NotFound —— 那会让人以为自己的资料没了。
          { path: 'profile', element: <Navigate to="/" replace /> },
          // 打款链路与成员名单：member 进不来。上面三页（概览 / 收款信息收集 / 收款人）
          // 才是 member 的全部视野。服务端另有 requireAdminOrFinance 把关。
          {
            element: <RequireAdminOrFinance />,
            children: [
              { path: 'payout-applications', element: <PayoutApplications /> },
              { path: 'payout-applications/ai-batch', element: <AiBatchApplications /> },
              { path: 'payout-batch-import', element: <PayoutBatchImport /> },
              { path: 'payouts', element: <Payouts /> },
              { path: 'members', element: <Members /> },
            ],
          },
          // 设置页只有管理员能进；服务端另有 requireAdmin 把关
          { element: <RequireAdmin />, children: [{ path: 'settings', element: <Settings /> }] },
          { path: '*', element: <NotFound /> },
        ],
      },
    ],
  },
]);
